module.exports = __webpack_public_path__ + "media/landing-page/postnl-bubble-5ce0fb3c.png";